export enum ButtonClicked {
  SolutionClicked = 'solution_clicked',
  SolutionDeepLink = 'article_internal_link',
  SolutionLinkInternal = 'Solution Link Internal',
  Back = 'back',
  OpenArticleInHC = 'open_in_help_center',
  RecommendedArticle = 'recommended_article',
  ExpandArticleSection = 'article_section_expend',
  CollapseArticleSection = 'article_section_collapse',
  ArticleExternalLink = 'article_external_link',
  ArticleTabSelection = 'tab_selection',
  CategorySelection = 'category_selection',
  SubCategorySelection = 'sub_category_selection',
  SearchBarTextTyping = 'search_bar_text_typing',
  ClearSearchBar = 'clear_search_bar',
  HelpCenter = 'help_center',
  MoreHelpResources = 'more_help_resources',
  HirePartner = 'hire_a_partner',
  ContactUs = 'contact_us',
  ChatWithUs = 'chat_with_us',
  StatusPage = 'status_page',
  Breadcrumbs = 'breadcrumbs',
  CloseKbWidget = 'close_kb_widget',
  Notifications = 'chatbot_notifications',
  ContactPartnerSuccessTeam = 'contact_the_partner_success_team',
  RequestFeature = 'request_a_feature',
  ReportBug = 'report_a_bug',
  RequestSuccessManagerClick = 'get_access_to_the_partner_success_team',
  FeatureRequestVote = 'feature_request_vote',
  FeatureRequestUnvote = 'feature_request_unvote',
  FeatureRequestFollow = 'feature_request_follow',
  FeatureRequestUnfollow = 'feature_request_unfollow',
  KnownIssueVote = 'known_issue_vote',
  KnownIssueUnvote = 'known_issue_unvote',
}
